<template>
  <v-content>
    <Header></Header>

    <v-layout justify-center align-center mt-1>
      <v-flex
        style="background-color: #F8F8F8;margin-bottom: 8rem"
        class="lg7 md8 sm9 xs11"
        :style="
          $vuetify.breakpoint.smAndUp
            ? { 'background-color': '#fff', padding: '4rem 4rem 15rem 4rem' }
            : {
                'background-color': '#fff',
                padding: '1rem 1rem 5rem 1rem',
                margin: '2rem 0 7rem 0',
              }
        "
      >
        <v-layout>
          <v-flex class="flex-center" style="font-size: 30px">
            {{ $t("forgot-password") }}
          </v-flex>
        </v-layout>
        <v-layout justify-center mt-3>
          <v-flex
            class="text-center lg5 md7 sm9 xs12"
            style="font-size: 14px;color:#FD5246"
          >
            <p>
              {{ $t("forgot-pw-desc") }}
            </p>
          </v-flex>
        </v-layout>

        <!-- form  -->
        <v-layout justify-center mt-12>
          <v-flex class="text-center lg7 md8">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
              <div class="d-flex text-center font-weight-bold">
                {{ $t("email") }}
              </div>
              <v-text-field
                background-color="#E5E5E5"
                dense
                solo
                flat
                v-model="email"
                class="mt-2 radius8"
                required
                :rules="emailRules"
              ></v-text-field>
            </v-form>
          </v-flex>
        </v-layout>

        <v-layout justify-center mt-4>
          <v-flex lg7 md8>
            <v-btn
              v-if="valid"
              dark
              block
              depressed
              color="#FD5246"
              @click="sendResetRequest"
            >
              {{ $t("send-pw-reset") }}
            </v-btn>
            <v-btn v-else depressed dark color="#C5C5C5" block>
              {{ $t("send-pw-reset") }}
            </v-btn>

            <v-btn
              class="mt-5"
              block
              depressed
              outlined
              color="#FD5246"
              @click="backToLogin"
            >
              {{ $t("back-to-login") }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <Footer></Footer>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ForgotPassword",
  components: {
    Header,
    Footer,
    Loading,
  },
  data: () => ({
    valid: true,
    lazy: false,
    isLoading: false,
    fullPage: true,
    email: "",
    activateCode: "",
    new_password: "",
    confirm_password: "",
    gotActivationCode: false,
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  }),
  methods: {
    backToLogin() {
      this.$router.push("/login");
    },
    sendResetRequest() {
      if (this.emailIsCorrect(this.email)) {
        let data = {
          email: this.email,
        };
        this.isLoading = true;
        this.$store.dispatch("auth/forgetPassword", data).then((res) => {
          this.isLoading = false;
          if (res.status === 200) {
            this.$swal({
              icon: "warning",
              text: res.message,
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
          } else {
            this.$swal({
              icon: "warning",
              text: res.message,
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
          }
        });
      } else {
        this.isLoading = false;
        this.$swal({
          icon: "error",
          text: "Invalid email",
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
      }
    },
    emailIsCorrect(mail) {
      let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(mail) && mail !== "";
    },
    passwordIsCorrect(pw) {
      return pw.length >= 8;
    },
  },
};
</script>

<style scoped>
.gray-layer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
}
.footer {
  background-color: #f8f8f8;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: #f8f8f8;
  text-align: center;
}
</style>
